// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3BIoK","head":"Table_head__bc0zh","col":"Table_col__2Qsq3"};